import { ShieldCheck, MapPin, CheckCircle } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";


import AlBandarRotana from "../assets/images/Al-Bandar-Rotana.webp";
import AlHabtoor from "../assets/images/Al-Habtoor-Grand-Resort.webp";
import RegencyLuxury from "../assets/images/Regency-Luxury-Suites.webp";
import FortunePearl from "../assets/images/Fortune-Pearl-Hotel-Deira.jpg";
import FortuneGrand from "../assets/images/Fortune-Grand-Hotel-Deira.webp";


export default function Partners() {

    const partners = [
        {
            name: "Al Bandar Rotana",
            image: AlBandarRotana,
            location: "Dubai Creek"
        },
        {
            name: "Al Habtoor Grand Resort",
            image: AlHabtoor,
            location: "Dubai Marina"
        },
        {
            name: "Regency Luxury Suites",
            image: RegencyLuxury,
            location: "Dubai"
        },
        {
            name: "Fortune Pearl Hotel",
            image: FortunePearl,
            location: "Deira"
        },
        {
            name: "Fortune Grand Hotel",
            image: FortuneGrand,
            location: "Dubai"
        }
    ];


    return (

        <section className="pt-16 pb-0 lg:py-24 bg-gray-50 dark:bg-gray-950">


            <div className="container mx-auto px-6">


                {/* HEADER */}

                <div className="text-center mb-12">

                    <span className="
inline-flex
items-center
gap-2
px-5
py-2
rounded-full
bg-[#D9BB74]/20
text-[#0F766E]
dark:text-[#D9BB74]
text-sm
font-semibold
mb-5
">

                        <ShieldCheck size={16} />

                        Trusted Hotel Collection

                    </span>


                    <h2 className="
text-3xl
lg:text-4xl
font-bold
text-gray-900
dark:text-white
">

                        Our Premium Hotel Partners

                    </h2>


                    <p className="
mt-4
max-w-2xl
mx-auto
text-gray-600
dark:text-gray-400
">

                        Verified luxury hotels across UAE offering exclusive stays and special offers.

                    </p>


                </div>



                <Swiper

                    modules={[Autoplay]}

                    slidesPerView={1}

                    spaceBetween={18}

                    loop={true}

                    speed={5000}

                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false
                    }}

                    breakpoints={{

                        640: {
                            slidesPerView: 2
                        },

                        1024: {
                            slidesPerView: 3
                        }

                    }}

                >

                    {
                        partners.map((hotel, index) => (

                            <SwiperSlide key={index}>


                                <div className="
group
relative
overflow-hidden
rounded-[28px]
h-[300px]
sm:h-[340px]
lg:h-[360px]
shadow-xl
">


                                    <img

                                        src={hotel.image}

                                        className="
w-full
h-full
object-cover
transition
duration-700
group-hover:scale-110
"

                                    />


                                    <div className="
absolute
inset-0
bg-gradient-to-t
from-black/80
via-black/20
to-transparent
"/>



                                    <div className="
absolute
bottom-0
left-0
right-0
p-5
text-white
">


                                        <div className="
inline-flex
items-center
gap-2
bg-[#D9BB74]
text-[#1B1B1B]
px-2.5
py-1
rounded-full
text-xs
font-semibold
mb-3
">

                                            <CheckCircle size={13} />

                                            Verified Partner

                                        </div>



                                        <h3 className="
text-xl
lg:text-2xl
font-bold
">

                                            {hotel.name}

                                        </h3>


                                        <div className="
flex
items-center
gap-2
mt-2
text-white/80
">

                                            <MapPin size={16} />

                                            {hotel.location}

                                        </div>


                                    </div>


                                </div>


                            </SwiperSlide>

                        ))

                    }


                </Swiper>



            </div>


        </section>


    )

}